<template lang="pug">
article-item-page-template(:title="pageTitle", :loading="loading")
  template(#header)
    .text-h6(v-html="content.title")
  template(#main)
    .ck-content(v-html="content.text")
    grid-list.mt-4(col-width="260px")
      v-img.rounded.elevation-4.elevation-2.cursor-pointer(
        v-for="(img, i) in images",
        v-ripple,
        @click="index = i",
        :key="i",
        :src="img",
        width="260px",
        height="260px"
      )
    vue-gallery-slideshow(
      :images="images",
      :index="index",
      @close="index = null"
    )
  template(#bottom)
    facebook-comments.mb-4.mb-md-0(:href="server + $route.path")
  template(#side)
    communications-widget
</template>

<script>
import ArticleItemPageTemplate from "@/components/templates/ArticleItemPage";
import CommunicationsWidget from "@/components/widgets/Communications";
import VueGallerySlideshow from "vue-gallery-slideshow";
import FacebookComments from "@/components/widgets/FacebookComments";

const _config = {
  title: "PROJETOS",
  mod: "projects",
};

export default {
  data: () => ({
    loading: false,
    pageTitle: _config.title,
    index: null,
  }),
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    content() {
      return this.$rest(_config.mod).item;
    },
    images() {
      return this.content.imgs
        ? this.content.imgs.map((img) => this.files + "/" + img)
        : [];
    },
  },
  created() {
    this.loading = true;

    this.$rest(_config.mod)
      .get({ id: this.itemId })
      .then(() => (this.loading = false))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },
  watch: {
    itemId(v) {
      this.$rest(_config.mod).get({ id: v });
    },
  },
  components: {
    ArticleItemPageTemplate,
    CommunicationsWidget,
    VueGallerySlideshow,
    FacebookComments,
  },
};
</script>
